export default __webpack_public_path__ + "static/media/hht2_ep15_speaking_02.0906fc04.png";